// Shared metadata for points-of-sale ("Onde Estamos").
// Keep in sync with backend LOCATION_TYPES & LINE_KEYS.

export const LOCATION_TYPE_META = {
    cafe: { label: "Café", emoji: "☕" },
    restaurante: { label: "Restaurante", emoji: "🍽️" },
    ginasio: { label: "Ginásio", emoji: "💪" },
    hotel: { label: "Hotel", emoji: "🏨" },
    quiosque: { label: "Quiosque", emoji: "🥤" },
    evento: { label: "Evento", emoji: "🎪" },
    outro: { label: "Outro", emoji: "📍" },
};

export const LINE_META = {
    fruit: { label: "FRUIT", color: "bg-brand-orange-soft text-brand-orange" },
    detox: { label: "DETOX", color: "bg-brand-green-soft text-brand-green" },
    protein: { label: "PROTEIN", color: "bg-brand-pink text-[#D63654]" },
    tea: { label: "TEA", color: "bg-brand-yellow text-[#C89800]" },
};

export const LOCATION_TYPE_OPTIONS = Object.entries(LOCATION_TYPE_META).map(
    ([k, v]) => ({ value: k, label: v.label, emoji: v.emoji }),
);

export const LINE_OPTIONS = Object.entries(LINE_META).map(([k, v]) => ({
    value: k,
    label: v.label,
}));
